import {
  RETRIEVE_ORDERS,
  RETRIEVE_ORDER_VIEW,
  UPDATE_ORDER_STATUS,
  DELETE_ORDER,
  RESTORE_ORDER,
} from "../actions/types";

const initialState = { orders: [], totalOrderCount: 0 };

const orderReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_ORDERS:
      return {
        orders: payload.rows,
        totalOrderCount: payload.count,
      };

    case RETRIEVE_ORDER_VIEW:
      return payload;

    case UPDATE_ORDER_STATUS:
      return {
        orders: payload.rows,
        totalOrderCount: state.totalOrderCount,
      };

    case DELETE_ORDER:
      return {
        ...state,
        orders: payload.rows,
        totalOrderCount: state.totalOrderCount,
      };

    case RESTORE_ORDER:
      return {
        ...state,
        orders: payload.rows,
        totalOrderCount: state.totalOrderCount,
      };


    default:
      return state;
  }
};

export default orderReducer;